// Enphase Customer
import iconYes from './../../images/icon-circle-yes.svg';
import iconYesHover from './../../images/icon-circle-yes-white.svg';
import iconNo from './../../images/icon-circle-no.svg';
import iconNoHover from './../../images/icon-circle-no-white.svg';

// Customer Home
import iconUpgradeSystem from './../../images/icon-home-upgrade-system.svg';
import iconUpgradeSystemHover from './../../images/icon-home-upgrade-system-white.svg';
import iconEvCharger from './../../images/icon-ev-charger.svg';
import iconEvChargerHover from './../../images/icon-ev-charger-white.svg';
import iconSupport from './../../images/icon-support.svg';
import iconSupportHover from './../../images/icon-support-white.svg';

// Upgrade System
import iconSolar from './../../images/icon-sunlight.svg';
import iconSolarHover from './../../images/icon-sunlight-white.svg';
import iconBattery from './../../images/icon-battery-only.svg';
import iconBatteryHover from './../../images/icon-battery-only-white.svg';
import iconSolarAndBattery from './../../images/icon-home-solar-and-battery.svg';
import iconSolarAndBatteryHover from './../../images/icon-home-solar-and-battery-white.svg';
import iconUpgradeMicroinverter from './../../images/icon-microinverter.svg';
import iconUpgradeMicroinverterHover from './../../images/icon-microinverter-white.svg';

// Property
import iconHome from './../../images/icon-home.svg';
import iconHomeHover from './../../images/icon-home-white.svg';
import iconCondo from './../../images/icon-condo.svg';
import iconCondoHover from './../../images/icon-condo-white.svg';
import iconMobile from './../../images/icon-mobile.svg';
import iconMobileHover from './../../images/icon-mobile-white.svg';
import iconCommercial from './../../images/icon-commercial.svg';
import iconCommercialHover from './../../images/icon-commercial-white.svg';

// Sunlight
import iconAlot from './../../images/icon-sunlight.svg';
import iconAlotHover from './../../images/icon-sunlight-white.svg';
import iconSome from './../../images/icon-sunlight-some.svg';
import iconSomeHover from './../../images/icon-sunlight-some-white.svg';
import iconNotMuch from './../../images/icon-sunlight-notmuch.svg';
import iconNotMuchHover from './../../images/icon-sunlight-notmuch-white.svg';
import iconUncertain from './../../images/icon-sunlight-uncertain.svg';
import iconUncertainHover from './../../images/icon-sunlight-uncertain-lightgrey.svg';

export const enphaseCustomerIcons = [
  { name: 'yes', path: iconYes },
  { name: 'yesHover', path: iconYesHover },
  { name: 'no', path: iconNo },
  { name: 'noHover', path: iconNoHover },
];

export const customerHomeIcons = [
  { name: 'upgradeSystem', path: iconUpgradeSystem },
  { name: 'upgradeSystemHover', path: iconUpgradeSystemHover },
  { name: 'iconEvCharger', path: iconEvCharger },
  { name: 'iconEvChargerHover', path: iconEvChargerHover },
  { name: 'support', path: iconSupport },
  { name: 'supportHover', path: iconSupportHover },
];

export const upgradeSystemIcons = [
  { name: 'solar', path: iconSolar },
  { name: 'solarHover', path: iconSolarHover },
  { name: 'battery', path: iconBattery },
  { name: 'batteryHover', path: iconBatteryHover },
  { name: 'solarAndBattery', path: iconSolarAndBattery },
  { name: 'solarAndBatteryHover', path: iconSolarAndBatteryHover },
  { name: 'upgradeMicroinverter', path: iconUpgradeMicroinverter },
  { name: 'upgradeMicroinverterHover', path: iconUpgradeMicroinverterHover },
];

export const propertyIcons = [
  { name: 'home', path: iconHome },
  { name: 'homeHover', path: iconHomeHover },
  { name: 'condo', path: iconCondo },
  { name: 'condoHover', path: iconCondoHover },
  { name: 'mobile', path: iconMobile },
  { name: 'mobileHover', path: iconMobileHover },
  { name: 'commercial', path: iconCommercial },
  { name: 'commercialHover', path: iconCommercialHover },
];

export const sunlightIcons = [
  { name: 'alot', path: iconAlot },
  { name: 'alotHover', path: iconAlotHover },
  { name: 'some', path: iconSome },
  { name: 'someHover', path: iconSomeHover },
  { name: 'notmuch', path: iconNotMuch },
  { name: 'notmuchHover', path: iconNotMuchHover },
  { name: 'uncertain', path: iconUncertain },
  { name: 'uncertainHover', path: iconUncertainHover },
];
